import * as stagesDivorce from "../../Stages/StagesDivorce";
import { stageMetaDataDivorce } from "../../Stages/StagesDivorce";
import { getRequiredFields, validateFields } from "../statusChangeValidators";
import { Divorce } from "../../../types/Products/FamilyLaw/Divorce";

const validateFieldsForStage = (divorce: Divorce, stage: keyof typeof stageMetaDataDivorce) =>
  validateFields(getRequiredFields(divorce, stage), divorce);

export const divorceValidators = {
  [stagesDivorce.STAGE_INCOMPLETE]: (divorce: Divorce) => {
    return validateFields([], divorce);
  },
  [stagesDivorce.STAGE_READY]: (divorce: Divorce) => {
    return validateFieldsForStage(divorce, stagesDivorce.STAGE_READY);
  },
  [stagesDivorce.STAGE_CHECKED]: (divorce: Divorce) => {
    return validateFieldsForStage(divorce, stagesDivorce.STAGE_CHECKED);
  },
  [stagesDivorce.STAGE_PROCESS_PAID]: (divorce: Divorce) => {
    return validateFieldsForStage(divorce, stagesDivorce.STAGE_PROCESS_PAID);
  },
  [stagesDivorce.STAGE_SUBMITTED]: (divorce: Divorce) => {
    return validateFieldsForStage(divorce, stagesDivorce.STAGE_SUBMITTED);
  },
  [stagesDivorce.STAGE_JUDICIAL_PROCESS]: (divorce: Divorce) => {
    return validateFieldsForStage(divorce, stagesDivorce.STAGE_JUDICIAL_PROCESS);
  },
  [stagesDivorce.STAGE_DATE_SET]: (divorce: Divorce) => {
    return validateFieldsForStage(divorce, stagesDivorce.STAGE_DATE_SET);
  },
  [stagesDivorce.STAGE_HEARING_PAID]: (divorce: Divorce) => {
    return validateFieldsForStage(divorce, stagesDivorce.STAGE_HEARING_PAID);
  },
  [stagesDivorce.STAGE_DIVORCE_DONE]: (divorce: Divorce) => {
    return validateFieldsForStage(divorce, stagesDivorce.STAGE_DIVORCE_DONE);
  },
  [stagesDivorce.STAGE_COMPLETED]: (divorce: Divorce) => {
    return validateFieldsForStage(divorce, stagesDivorce.STAGE_COMPLETED);
  },
};
